import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="eyebrow">// 404</div>
        <h1 className="display-xl text-silver-50 mt-3">Signal lost.</h1>
        <p className="text-silver-300 mt-4">That page isn't on the grid.</p>
        <Link to="/" className="btn-primary mt-8 inline-flex">Return to base</Link>
      </div>
    </div>
  );
}
